import { render, staticRenderFns } from "./MarkdownAiChatDlg.vue?vue&type=template&id=5cad70d9&scoped=true&"
import script from "./MarkdownAiChatDlg.vue?vue&type=script&lang=ts&"
export * from "./MarkdownAiChatDlg.vue?vue&type=script&lang=ts&"
import style0 from "./MarkdownAiChatDlg.vue?vue&type=style&index=0&id=5cad70d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cad70d9",
  null
  
)

export default component.exports